// extracted by mini-css-extract-plugin
module.exports = {"component":"story-login-modal_component__1Q2E6"};